import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AlertController, ModalController } from '@ionic/angular';
import { BoardHelpService } from '../../../match-tracker/tracker-board/board-help.service';
import { TimeItem } from '../../../_shared/models/csTypes/time_item';
import { Infringement } from '../../../_shared/models/infringements.model';
import { Match } from '../../../_shared/models/match.model';
import { DatePipe } from '@angular/common';

@Component({
  standalone: false,
    selector: 'app-infringement-details',
    templateUrl: './infringement-details.component.html',
    styleUrls: ['./infringement-details.component.scss'],
})
export class InfringementDetailsComponent implements OnInit {

    @Input({required: true}) match: Match;
    @Input() infringementTimeItem: TimeItem;
    @Input() isCreate: boolean;

    form: UntypedFormGroup;
    isEdit: boolean;
    formActive: boolean;
    infringement: Infringement;

    participantSide1: string;
    participantSide2: string;

    constructor(
        private alertController: AlertController,
        private modalController: ModalController,
        private fb: UntypedFormBuilder,
        private bhs: BoardHelpService
    ) { }

    ngOnInit() {
        this.infringement = this.infringementTimeItem.itemValue;

        this.buildForm();
        this.participantSide1 = this.bhs.getPlayersNames(this.match, 1, 'full');
        this.participantSide2 = this.bhs.getPlayersNames(this.match, 2, 'full');
    }

    buildForm() {
        this.form = this.fb.group({
            note: [this.infringement?.note]
        });

        this.formActive = true;
    }

    async delete() {
        const alert = await this.alertController.create({
            header: 'Delete infringement',
            message: 'This action cannot be undone. Do you want to continue.',
            buttons: [
                {
                    text: 'Yes, delete',
                    role: 'destructive',
                    handler: async () => {
                        await alert.dismiss();
                        (await this.modalController.getTop()).dismiss({
                            action: 'DELETE'
                        });
                    }
                },
                {
                    text: 'Cancel',
                    role: 'cancel'
                }
            ]
        });

        await alert.present();
    }

    async save() {
        this.infringement.note = this.form.get('note').value;
        (await this.modalController.getTop()).dismiss({
            action: this.isCreate ? 'CREATE' : 'EDIT',
            value: this.infringementTimeItem
        });
    }

    async close() {
        (await this.modalController.getTop()).dismiss();
    }

    convertDuration(duration): string {
        return new DatePipe('en-US').transform(new Date(0, 0, 0).setMilliseconds(duration), 'H:mm');
    }

}
